import React from 'react';
import {connect} from 'react-redux';
import StepHeader from './StepHeader';
import Button from '../Button';
import {promoCodePanelCancel,promoCodePanelChange,promoCodePanelSubmit} from '../../actions/creators/checkout/tickets';
import { useRecaptcha } from '../../hooks/useRecaptcha';

const maxLength = 16;
const formatCode = v => v.replace(/[^\d]/g, '').substr(0, maxLength);

interface Props {
  code: string;
  onCancel: () => void;
  onChange: (code: string) => void;
  onSubmit: (code: string, captcha: string) => void;
  getToken: (action: string) => Promise<string>;
}

const PromoCodePanel = ({ code, onCancel, onChange, onSubmit }: Props) => {
  const { getToken } = useRecaptcha();
  
  const handleChange = e => {
    const nextCode = e.target.value;
    onChange(nextCode);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const token = await getToken('submit');
    onSubmit(code, token);
  };

  return (
    <div className="col-12 col-lg-8">
      <StepHeader timer={false} onPrevClick={onCancel} label="Ingresa un código promocional" />

      <form onSubmit={handleSubmit}>
        <div className="form-group mb-5">
          <label htmlFor="promoCode">Código:</label>
          <input type="text" className="form-control form-control-lg" id="promoCode" placeholder="0123456789" autoFocus required
            value={code} onChange={handleChange}
          />
        </div>
        <Button submit primary large block disabled={code === ''}>Aplicar código</Button>
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  code: state.checkoutData.promoCode.temp,
});

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(promoCodePanelCancel()),
  onChange: code => dispatch(promoCodePanelChange(code)),
  onSubmit: (code, captcha) => dispatch(promoCodePanelSubmit(code, captcha)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PromoCodePanel);